module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/297.3adff58d.png";